import React from "react";

/**
 * Route-level gate for superuser-only Skills Profile admin pages
 * (Item Selection, LLM Tags).
 *
 * Gated by can_access_client_admin from adminUserData (injected by SidebarView).
 * Matches the same superuser predicate used in AdminSide and Client/User/Ednition admin.
 */
export const SuperuserGuard = ({ adminUserData, children }) => {
  const isSuperuser = adminUserData?.can_access_client_admin || false;

  if (!isSuperuser) {
    return (
      <div
        data-testid="superuser-access-denied"
        style={{
          padding: "48px",
          textAlign: "center",
          color: "#666",
        }}
      >
        <h3>Access denied</h3>
        <p>This page requires superuser privileges.</p>
      </div>
    );
  }

  // Pass adminUserData down only to custom React components, not intrinsic DOM elements
  return (
    <>
      {React.Children.map(children, (child) =>
        React.isValidElement(child) && typeof child.type !== "string"
          ? React.cloneElement(child, { adminUserData })
          : child
      )}
    </>
  );
};
